import VisualPlannerOverview from "@/features/visual_planner/views/OverviewView.vue";

export default [
  {
    path: "/visual-planer",
    name: "visual-planer",
    component: VisualPlannerOverview,
  },
];
